import { render, staticRenderFns } from "./AvatarForm.vue?vue&type=template&id=cbfa2f18&scoped=true"
import script from "./AvatarForm.vue?vue&type=script&lang=js"
export * from "./AvatarForm.vue?vue&type=script&lang=js"
import style0 from "./AvatarForm.vue?vue&type=style&index=0&id=cbfa2f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa2f18",
  null
  
)

export default component.exports